import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import flowerService from "../../service/flower";
import { Flower, FlowerParams, FlowerState, FlowerUpdate } from "../../@type/flowerType";



export const getFlower = createAsyncThunk(
    "get/getFlower",
    async (params?: FlowerParams) => {
      const { data } = await flowerService.get(params);
      return data;
    }
  );
  export const getByFlowerId = createAsyncThunk(
    "get/getByIDFlower",
    async (id: number) => {
      const { data } = await flowerService.getById(id);
      return data;
    }
  );
  export const postFlower = createAsyncThunk(
    "post/postFlower",
    async (FlowerData: Flower) => {
      const { data } = await flowerService.post(FlowerData);
      return data;
    }
  );
  export const updateFlower = createAsyncThunk(
    "update/updateFlower",
    async ({ id, flowerData }: { id: number; flowerData: FlowerUpdate }) => {
      const { data } = await flowerService.put(id, flowerData);
      return data;
    }
  );
   export const deleteImageFlower = createAsyncThunk(
    "delete/imageFlower",
    async (id: number) => {
      const { data } = await flowerService.deleteImage(id);
      return data;
    }
  );
export const deleteFlower = createAsyncThunk(
  "delete/deleteFlower",
  async (id: number) => {
    await flowerService.delete(id);
    return id; // 👈 chỉ trả về id
  }
);

const initialState: FlowerState = {
  flowerList: [],
  flowerDetail: {
    flowerId:0,
    name:"",
    lifespan:"",
    origin:"",
    description:"",
    feature:"",
    meaning:"",
    groupName:"",
    price:0,
    groupId:0,
    images:[],
  }
};

const FlowerSlice = createSlice({
  name: "Flower",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFlower.fulfilled, (state, action) => {
      state.flowerList = action.payload.data;
    });
    builder.addCase(postFlower.fulfilled, (state, action) => {
      state.flowerList.push(action.payload);
    });
    builder.addCase(getByFlowerId.fulfilled, (state, action) => {
      state.flowerDetail = action.payload.data;
    });
    builder.addCase(updateFlower.fulfilled, (state, action) => {
      state.flowerDetail = action.payload.data;
    });
      builder.addCase(deleteFlower.fulfilled, (state, action) => {
  state.flowerList = state.flowerList.filter(
    (item) => item.flowerId !== action.payload
  );
});

    builder.addCase(deleteImageFlower.fulfilled, (state, action) => {
         state.flowerDetail = action.payload.data;

    }); 
  },
});

export default FlowerSlice.reducer;
